export const zeroIfNan = (value) => {
    const max = parseInt(value, 10);
    return Number.isNaN(max) ? 0 : max;
}

/**
 * Floors a monetary value down to the nearest penny, e.g. 12.349 -> 12.34.
 * The small epsilon guards against float artefacts such as 0.29 * 100 = 28.999...
 */
export const floorToPennies = (value) => {
    const number = Number(value);
    if (Number.isNaN(number)) { return 0; }
    return Math.floor(number * 100 + 1e-9) / 100;
}

/**
 * Whether the driver may select their own tax band on Your Profile, overriding their Jaama tax band.
 * Only BCH products can disable this; a missing setting allows it.
 */
export const isTaxBandSelectionAllowed = (product) => product?.your_profile_allow_tax_band_selection !== false;
